import styled from 'styled-components';
import { Body2 } from '../../../typography';
import { getColor, getSizeBy } from '../../../../../src/styled/utils';
import { MenuListItem } from '../../../menu';
export const StyledFileCard = styled.div `
  display: grid;
  grid-column-gap: ${getSizeBy(2)};
  grid-template-columns: ${getSizeBy(10)} auto minmax(${getSizeBy(10)}, auto);
  align-items: center;
  width: 100%;
  padding: ${getSizeBy(2)} ${getSizeBy(3)};
  background-color: ${getColor('surface')};
`;
export const FileInfoWrap = styled.div `
  overflow: hidden;
`;
export const FileName = styled(Body2) `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const StyledActionButtons = styled.div `
  justify-self: end;
`;
export const StyledDownloadMenuItem = styled(MenuListItem) `
  text-decoration: none;
`;
